"use strict"

const showError = () => {
  throw new Error(`Rota de leitura deve conter o padrão 17 26000 17 016200`)
}

const validator = (
  data: { original: Record<string, string> },
  field: string
) => {
  const reading_route = data.original[field]
  if (!reading_route) return true
  const split = reading_route.split(" ")

  if (split.length != 4) showError()
  else if (split[0].length != 2) showError()
  else if (split[1].length != 5) showError()
  else if (split[2].length != 2) showError()
  else if (split[3].length != 6) showError()
  return true
}

export const readingRoute = {
  async: false,
  validate: validator,
}
